/**
 * @desc 仓库绩效报表查询结果汇总
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.inoutStepRecord.getInoutStepRecordWarehousePerformanceSummary.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inoutStepRecord/warehousePerformanceSummary`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
